import styled from "styled-components";

const Button = ({
  message,
  handleTabKey = null,
  tabPressed = null,
  id = null,
  inputRef = null,
  onClickEvent =null
}) => {
  return (
    <StyledButton
      ref={inputRef}
      tabIndex={2}
      onKeyDown={(e) => {
        if (e.key === "Tab" && handleTabKey) {
          e.preventDefault();
          handleTabKey(id);
        }
        else if(e.key==="Enter" && onClickEvent){
          e.preventDefault();
          onClickEvent();
        }
      }}
    >
      <div name="color wrapper"></div>
      <p>{message}</p>
    </StyledButton>
  );
};

const StyledButton = styled.div`
  width: 400px;
  height: 56px;
  border-radius: 10px;
  background-color: #1167ed;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  > div {
    width: 400px;
    height: 56px;
    border-radius: 10px;
    background-color: transparent;
    position: absolute;
  }
  > div:hover {
    background-color: #000000;
    opacity: 0.2;
  }
  > p {
    font-family: "notoSans-medium";
    font-size: 16px;
    color: #ffffff;
    z-index: 1;
  }
`;

export default Button;
